module.exports = __webpack_public_path__ + "img/bg-magento-find-out_small.4bab1eba.jpg";